import { render } from "./newTable.vue?vue&type=template&id=41c230a0&scoped=true&ts=true"
import script from "./newTable.vue?vue&type=script&lang=ts"
export * from "./newTable.vue?vue&type=script&lang=ts"

import "./newTable.vue?vue&type=style&index=0&id=41c230a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c230a0"]])

export default __exports__